module.exports = __webpack_public_path__ + "media/images/matching-2-a2d9aec305ef79e6d3d7152b81b7f128.jpg";